import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'defaultIpProfile'
})
export class RolesDisplayPipe implements PipeTransform {

  transform(value: any, row: any): any {
    if (_.isEmpty(value)) { return ''; }

    return value.map(role => _.startCase(role.toLowerCase())).join(', ');
  }

}
